import { load } from "@shopify/theme-sections";
import { add, listen, qs } from "@fluorescent/dom";
import isMobile from "is-mobile";

import pageTransition from "@/lib/page-transition";
import modal from "@/lib/modal";
import storeAvailabilityDrawer from "@/lib/store-availability-drawer";
import { handleTab } from "@/lib/a11y";
import sectionClasses from "@/lib/section-classes";
import { hydrate } from "@/glow/events";
import quickAdd from "@/lib/quick-add";
import quickAddModal from "@/lib/quick-add-modal";

// Initialize lazysizes
import "lazysizes/plugins/object-fit/ls.object-fit";
import "lazysizes/plugins/parent-fit/ls.parent-fit";
import "lazysizes/plugins/rias/ls.rias";
import "lazysizes/plugins/bgset/ls.bgset";
import "lazysizes";
import "lazysizes/plugins/respimg/ls.respimg";

// Import sections
import "@/sections";

// Detect theme editor
if (window.Shopify.designMode === true) {
  add(document.documentElement, "theme-editor");
  document.documentElement.classList.add("theme-editor");
} else {
  const el = qs(".theme-editor-scroll-offset", document);
  el && el.parentNode.removeChild(el);
}

// Function to load all sections
const loadSections = () => {
  load("*");
  hydrate({ SelectedProductSection: null });
};

// Call above function either immediately or bind on loaded event
if (
  document.readyState === "complete" ||
  document.readyState === "interactive"
) {
  loadSections();
} else {
  listen(document, "DOMContentLoaded", loadSections);
}

if (isMobile({ tablet: true, featureDetect: true })) {
  add(document.body, "is-mobile");
}

// Page transitions
pageTransition();

// a11y tab handler
handleTab();

// Apply contrast classes
sectionClasses();

// Quick add to cart
quickAdd();

// Quick add modal
const quickAddModalElement = qs("[data-quick-add-modal]", document);

if (quickAddModalElement) {
  quickAddModal(quickAddModalElement);
}

// Setup modal
const modalElement = qs("[data-modal]", document);
modal(modalElement);

// Product availabilty drawer
const availabilityDrawer = qs("[data-store-availability-drawer]", document);
storeAvailabilityDrawer(availabilityDrawer);

// Make it easy to see exactly what theme version
// this is by commit SHA

window.SHA = "__gitSHA";

if (
  !sessionStorage.getItem("flu_stat_recorded") &&
  !window.Shopify?.designMode
) {
  // eslint-disable-next-line no-process-env
  fetch(process.env.FLU_STATS_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ...window.theme.coreData,
      s: window.Shopify?.shop,
      r: window.Shopify?.theme?.role,
    }),
  });

  if (window.sessionStorage) {
    sessionStorage.setItem("flu_stat_recorded", "true");
  }
}
